// once — theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Logo mask URL ────────────────────────────────────────────
  const logoUrl = document.querySelector('[data-logo-url]')?.dataset.logoUrl;
  if (logoUrl) {
    document.querySelectorAll('.once-logo').forEach(el => {
      el.style.webkitMaskImage = `url(${logoUrl})`;
      el.style.maskImage = `url(${logoUrl})`;
    });
  }

  // ── Nav scroll shadow ────────────────────────────────────────
  const nav = document.getElementById('once-nav');
  window.addEventListener('scroll', () => {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });

  // ── Mobile menu ──────────────────────────────────────────────
  const menuBtn   = document.getElementById('once-menu-btn');
  const menuClose = document.getElementById('once-menu-close');
  const menu      = document.getElementById('once-menu');
  if (menuBtn) menuBtn.addEventListener('click', () => menu.classList.add('open'));
  if (menuClose) menuClose.addEventListener('click', () => menu.classList.remove('open'));

  // ── Scroll fade-in observer ──────────────────────────────────
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('vis'); });
  }, { threshold: 0.07 });
  document.querySelectorAll('.fi').forEach(el => io.observe(el));

  // ── Horizontal scroll dots ───────────────────────────────────
  const hs   = document.getElementById('once-hscroll');
  const dots = document.querySelectorAll('.once-sdot');
  if (hs && dots.length) {
    hs.addEventListener('scroll', () => {
      const pct = hs.scrollLeft / (hs.scrollWidth - hs.clientWidth);
      const idx = Math.round(pct * (dots.length - 1));
      dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => {
      hs.scrollTo({ left: (hs.scrollWidth - hs.clientWidth) / (dots.length - 1) * i, behavior: 'smooth' });
    }));
  }

  // ── Cart count (Shopify AJAX API) ────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const el = document.querySelector('.once-cart-count');
        if (el) el.textContent = cart.item_count;
      });
  }
  updateCartCount();

  // ── Quick Add ────────────────────────────────────────────────
  document.querySelectorAll('.once-quick-add').forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      const orig = this.innerHTML;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(() => {
        this.textContent = '✓ Added';
        this.classList.add('added');
        updateCartCount();
        setTimeout(() => { this.innerHTML = orig; this.classList.remove('added'); }, 1500);
      });
    });
  });

  // ── Color swatch switch ──────────────────────────────────────
  document.querySelectorAll('.once-swatch').forEach(swatch => {
    swatch.addEventListener('click', function () {
      const card = this.closest('.once-pcard, .once-pgrid-card');
      if (!card) return;
      this.closest('.once-swatches').querySelectorAll('.once-swatch').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      const img = card.querySelector('.once-pcard-img img');
      if (img && this.dataset.image) img.src = this.dataset.image;
      const varEl = card.querySelector('.once-pcard-var');
      if (varEl) varEl.textContent = this.title || '';
      const qBtn = card.querySelector('.once-quick-add');
      if (qBtn && this.dataset.variantId) qBtn.dataset.variantId = this.dataset.variantId;
    });
  });

  // ── Product filter tabs ──────────────────────────────────────
  document.querySelectorAll('.once-ftab').forEach(tab => {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.once-ftab').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const cat = this.dataset.filter;
      document.querySelectorAll('.once-pgrid-card').forEach(card => {
        const c = card.dataset.cat;
        card.style.display = (cat === 'all' || c === cat || c === 'all') ? '' : 'none';
      });
    });
  });

  // ── Recommended slider dots ───────────────────────────────────
  const recSlider = document.getElementById('once-rec-slider');
  const recDotsEl = document.getElementById('once-rec-dots');
  if (recSlider && recDotsEl) {
    const cards   = recSlider.querySelectorAll('.once-rec-card');
    const visible = () => Math.round(recSlider.clientWidth / cards[0].offsetWidth);
    const total   = () => Math.max(1, cards.length - visible() + 1);

    function buildDots() {
      recDotsEl.innerHTML = '';
      for (let i = 0; i < total(); i++) {
        const d = document.createElement('div');
        d.className = 'once-rec-dot' + (i === 0 ? ' active' : '');
        d.addEventListener('click', () => {
          const w = cards[0].offsetWidth + 8;
          recSlider.scrollTo({ left: w * i, behavior: 'smooth' });
        });
        recDotsEl.appendChild(d);
      }
    }
    buildDots();
    window.addEventListener('resize', buildDots);

    recSlider.addEventListener('scroll', () => {
      const w   = cards[0].offsetWidth + 8;
      const idx = Math.round(recSlider.scrollLeft / w);
      recDotsEl.querySelectorAll('.once-rec-dot').forEach((d, i) => {
        d.classList.toggle('active', i === idx);
      });
    }, { passive: true });
  }

  // ── Wishlist (localStorage) ───────────────────────────────────
  const WISHLIST_KEY = 'once_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  document.querySelectorAll('.once-pcard, .once-rec-card').forEach(card => {
    const imgWrap = card.querySelector('.once-pcard-img, .once-rec-img');
    if (!imgWrap) return;
    const productId = imgWrap.dataset.productId || '';

    const btn = document.createElement('button');
    btn.className = 'once-wishlist-btn';
    btn.setAttribute('aria-label', 'Add to Wishlist');
    btn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>`;

    if (productId && getWishlist().includes(String(productId))) {
      btn.classList.add('active');
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      let list = getWishlist();
      const id = String(productId);
      if (list.includes(id)) {
        list = list.filter(i => i !== id);
        btn.classList.remove('active');
      } else {
        list.push(id);
        btn.classList.add('active');
      }
      saveWishlist(list);
    });

    imgWrap.style.position = 'relative';
    imgWrap.appendChild(btn);
  });

});
window.onceColorClick = function(el, value) {

  // 色の表示を更新
  const label = document.getElementById('once-color-val');
  if (label) label.textContent = value;

  // active切り替え
  document.querySelectorAll('.once-swatch').forEach(sw => {
    sw.classList.remove('active');
  });
  el.classList.add('active');

  // バリエーションを切り替え
  const select = document.querySelector('form[action="/cart/add"] select[name="id"]');

  if (!select) return;

  [...select.options].forEach(option => {
    if (option.text.includes(value)) {
      select.value = option.value;
      select.dispatchEvent(new Event('change'));
    }
  });

};